module.exports = __webpack_public_path__ + "static/media/gal0809-05.a1d6fa39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal0809/gal0809-05.jpg
// module id = 530
// module chunks = 0